/**
 * Check if development features should be shown
 * @returns true if REACT_APP_SHOW_DEV_FEATURES is 'true', false otherwise
 */
export const isDevMode = (): boolean => {
  return process.env.REACT_APP_SHOW_DEV_FEATURES === 'true';
};
